import { Checkbox, DataSource, ExcludableTextbox, Layout, Switch, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutResponsibilityPendingActivitiesReport extends Layout {
    checkboxPageBreak: Checkbox;
    excludabletextboxCustomers: ExcludableTextbox;
    excludabletextboxMarketingActivities: ExcludableTextbox;
    excludabletextboxOperationsUser: ExcludableTextbox;
    excludabletextboxSalesManager: ExcludableTextbox;
    excludabletextboxSalesperson: ExcludableTextbox;
    sourceResponsibilityPendingActivitiesReport: DataSource;
    switchIncludePastDue: Switch;
    textboxCustomerProspectType: Textbox;
    textboxDueDate: Textbox;
    textboxDueDateSingle: Textbox;
    textboxGroupBy: Textbox;
    textboxHierarchyCode: Textbox;
    textboxHierarchyLevel: Textbox;
    textboxSortBy: Textbox;
}
